import React from 'react';
import {
	Box,
	Button,
	Typography,
	Alert,
	CircularProgress
} from '@mui/material';
import { useMutation } from '@apollo/client';
import { EXIT_IMPERSONATION } from '../../gql/queries';
import { useAuthContext } from '../../contexts/auth-context';
import { toast } from 'react-toastify';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

interface ImpersonationBannerProps {
	impersonatedUserEmail: string;
	impersonatedUserPhone: string;
}

const ImpersonationBanner: React.FC<ImpersonationBannerProps> = ({ 
	impersonatedUserEmail,
	impersonatedUserPhone
}) => {
	const { impersonateUser } = useAuthContext();

	const [exitImpersonation, { loading }] = useMutation(EXIT_IMPERSONATION, {
		onCompleted: (data) => {
			// Store the new token and reload the page
			const token = data.exitImpersonation;
			if (token) {
				impersonateUser(token);
				toast.success('Exited impersonation mode');
				// Reload to refresh the UI with the original user context
				window.location.reload();
			}
		},
		onError: (error) => {
			toast.error(`Error exiting impersonation: ${error.message}`);
		}
	});

	const handleExit = () => {
		exitImpersonation();
	};

	return (
		<Alert 
			severity="warning" 
			sx={{ 
				width: '100%', 
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				mb: 2
			}}
		>
			<Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
				<Typography variant="body1">
					<strong>IMPERSONATION MODE</strong>: You are currently impersonating user {impersonatedUserEmail} ({impersonatedUserPhone})
				</Typography>
			</Box>
			<Button
				variant="outlined"
				color="inherit"
				size="small"
				onClick={handleExit}
				disabled={loading}
				startIcon={loading ? <CircularProgress size={16} /> : <ExitToAppIcon />}
				sx={{ ml: 2 }}
			>
				Exit Impersonation
			</Button>
		</Alert>
	);
};

export default ImpersonationBanner;
